<template>
  <div>
    <v-container fluid class="mt-16">
      <v-row>
        <v-col cols="3"></v-col>
        <v-col>
          <v-card-text>
            <v-text-field
              disabled
              autofocus
              v-model="objetoNewPass.Usuario"
              label="Usuario"
              required
            ></v-text-field>
            <v-text-field
              :append-icon="showPassword1 ? 'mdi-eye' : 'mdi-eye-off'"
              :type="showPassword1 ? 'text' : 'password'"
              @click:append="showPassword1 = !showPassword1"
              v-model="objetoNewPass.Password"
              label="Nueva contraseña"
              required
            ></v-text-field>
          </v-card-text>
          <v-btn @click="resetearContrasena()" style="color:white;" color="green darken-1" block>
            ACEPTAR
          </v-btn>
        </v-col>
        <v-col cols="3"></v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data: () => ({ showPassword1: false, objetoNewPass: { Usuario: "", Password: "", Token: "" } }),
  props: {
    usuario: {
      type: String
    },
    token: {
      type: String
    }
  },
  methods: {
    ...mapActions("passwordReset", ["updatePasswordPaso2"]),
    resetearContrasena() {
      this.updatePasswordPaso2(this.objetoNewPass);
    }
  },
  mounted() {
    this.objetoNewPass.Usuario = this.usuario;
    this.objetoNewPass.Token = this.token;
  }
};
</script>
